/**
 * Query Key factory for all profile queries.
 *
 * @module Profile
 */

import { Pagination } from "@customTypes/index";


export const profileQKeys = {
  all: () => ["profiles"] as const,

  allWithFilters: (filters: {
    pagination?: Partial<Pagination>;
    search?: string;
    type?: string;
    visibility?: string;
    range?: string;
    startDate?: string;
    endDate?: string;
    cmode?: string;
    language?: string;
    yoe?: string;
    serviceId?: string;
    specialty?: string;
  }) => [...profileQKeys.all(), { ...filters }] as const,

  specialties: () => [...profileQKeys.all(), "specialties"] as const,

  byUserId: (userId: string) => [...profileQKeys.all(), "user", userId] as const,
};
